import RecoverStep from "../recover_step";

const TEMPLATE = 'virtualization-start-failover';
const REFRESH_FAILOVER_STATUS_URL = 'failover_status/';
const CLIENT_DETAILS_URL = 'client/details/';

export default class CreateFailover extends RecoverStep {

	constructor(failoverStatusUrl = REFRESH_FAILOVER_STATUS_URL, clientDetailsUrl = CLIENT_DETAILS_URL) {
		super(TEMPLATE);
		this.failoverStatusUrl = failoverStatusUrl;
		this.clientDetailsUrl = clientDetailsUrl;
	}

	open(data, el, fr, previousStep) {
		data.recovery.defer = $.Deferred();
		data.recovery.defer.done(() => {
			const needRedirect = (fr.existsInDOM() || $('#cc-failover-unavailable').is(':visible'));
			fr.close();
			if (needRedirect) {
				tabs_goto(this.clientDetailsUrl + data.clientId + '/1', 'li.clients-tab');
			}
		}).fail((reason) => {
			data.render.hasError = true;
			if (reason) {
				data.render.error = reason['_message_'];
			}
			fr.render('createFailover');
		}).always(() => {
			pollMeister.unsubscribe(this.failoverStatusUrl + data.recovery.failoverId);
		});
		fr.callMethod('checkFailoverStatus');
	}

	checkFailoverStatus(data, el, fr) {
		pollMeister.subscribe(this.failoverStatusUrl + data.recovery.failoverId, (response) => {
			const status = response.failover_status.phase;
			if (status === 'started') {
				data.recovery.defer.resolve();
			} else if (status !== 'new' && status !== 'finished') {
				data.render.loadingComplete = true;
				data.recovery.defer.reject(response.errors);
			} else if (response.status === 'failed') {
				if (fr.existsInDOM()) {
					fr.goTo('createFailoverFailed');
				} else {
					//redirect to site page if current page is starting VO page only
					const isStartingPage = $('#cc-failover-unavailable').length;
					if (isStartingPage > 0) {
						tabs_goto(this.clientDetailsUrl + data.clientId, 'li.clients-tab');
					}
					const flowcontainer = $("<div>").attr("data-flow-name", "recovery").css('height', '0px');
					$("#content").prepend(flowcontainer);
					const stepcontainer = $("<div>").attr("class", "stepcontainer");
					flowcontainer.append(stepcontainer);
					stepcontainer.html(Handlebars.compile(fr.cachedtemplates['createFailoverFailed'])(data));
				}
				pollMeister.unsubscribe(this.failoverStatusUrl + data.recovery.failoverId);
			}
		}, null);
	}

}
